import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface SearchState {
  booked: boolean
  previous: boolean
  tag?: string
  watching: boolean
}

const initialState: SearchState = {
  booked: false,
  previous: false,
  tag: undefined,
  watching: false,
}

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    update: (state, { payload }: PayloadAction<Partial<SearchState>>) => {
      console.debug({ state, payload })
      for (const key in payload) {
        switch (key as keyof typeof state) {
          case 'booked':
            state.booked = payload.booked!;
            break;
          case 'previous':
            state.previous = payload.previous!;
            break;
          case 'tag':
            state.tag = payload.tag;
            break;
          case 'watching':
            state.watching = payload.watching!;
            break;
        }
      }
    }
  }
});

export const { update } = searchSlice.actions;

export default searchSlice.reducer
